import ServiceBase from "@/app/services/ServiceBase.js"
import UserService from "@/app/services/UserService.js"
import { types } from '@/app/types/types';
import { authenticationEnum } from "@/app/enums/common";

const state = {
	[types.STATE_USER]: null,
	[types.STATE_IS_USER_LOGGED_IN]: null,
	[types.STATE_USER_RECENTITEMS]: null,
	[types.STATE_NOTIFICATIONS]: [],
	[types.STATE_LASTNOTIFICATIONID]: null,
	[types.STATE_NOTIFICATION_SHOWN]: null,
	[types.STATE_IS_NOTIFICATION_SHOWN]: false,
	notificationPollInterval: null
};

const getters = {
	[types.GET_USER_DATA]: (state) =>
	{
		return state[types.STATE_USER]
	},

	[types.GET_IS_USER_LOGGED_IN]: (state) =>
	{
		return state[types.STATE_IS_USER_LOGGED_IN]
	},

	[types.GET_USER_RECENTITEMS]: (state) =>
	{
		return state[types.STATE_USER_RECENTITEMS]
	},

	[types.GET_NOTIFICATIONS]: (state) =>
	{
		return state[types.STATE_NOTIFICATIONS]
	},

	[types.GET_NOTIFICATION_SHOWN]: (state) =>
	{
		return state[types.STATE_NOTIFICATION_SHOWN]
	},

	[types.GET_IS_NOTIFICATION_SHOWN]: (state) =>
	{
		return state[types.STATE_IS_NOTIFICATION_SHOWN]
	},

	[types.GET_LASTNOTIFICATIONID]: (state) =>
	{
		return state[types.STATE_LASTNOTIFICATIONID]
	}
};

const mutations = {
	[types.MUTATE_SET_USER_DATA]: (state, payload) =>
	{
		log("MUTATE_SET_USER_DATA")

		let currentUserState = state[types.STATE_USER]

		if (currentUserState)
		{
			if (!payload.token)
			{
				payload.token = currentUserState.token
			}

			if (!payload.expiration)
			{
				payload.expiration = currentUserState.expiration
			}
		}

		// Integrity check
		if (payload && payload.id && payload.name && payload.email && payload.role)
		{
			state[types.STATE_USER] = payload;
			state[types.STATE_IS_USER_LOGGED_IN] = true
			localStorage.setItem(types.STATE_USER, JSON.stringify(payload));
			ServiceBase.defaults.headers.common["Authorization"] = "Bearer " + payload.token;
		}
		else
		{
			log("MUTATE_SET_USER_DATA payload error: " + payload)
		}
	},

	[types.MUTATE_CLEAR_USER_DATA]: (state) =>
	{
		log("MUTATE_CLEAR_USER_DATA")
		state[types.STATE_USER] = null
		state[types.STATE_IS_USER_LOGGED_IN] = null
		localStorage.removeItem([types.STATE_USER])
		ServiceBase.defaults.headers.common = null
	},

	[types.MUTATE_SET_IS_USER_LOGGED_IN]: (state, payload) =>
	{
		log("MUTATE_SET_IS_USER_LOGGED_IN")
		state[types.STATE_IS_USER_LOGGED_IN] = payload;
	},

	[types.MUTATE_SET_USER_RECENTITEMS]: (state, payload) =>
	{
		log("MUTATE_SET_USER_RECENTITEMS")
		state[types.STATE_USER_RECENTITEMS] = payload;
	},

	[types.MUTATE_SET_USER_NOTIFICATIONS]: (state, payload) =>
	{
		log("MUTATE_SET_USER_NOTIFICATIONS")
		state[types.STATE_USER_NOTIFICATIONS] = payload;
	},

	[types.MUTATE_ADD_NOTIFICATIONS]: (state, payload) =>
	{
		log("MUTATE_ADD_NOTIFICATIONS")

		if (payload && payload.length > 0)
		{
			for (let notification of payload)
			{
				let findNotification = state[types.STATE_NOTIFICATIONS].find((notif) => { return notif.id == notification.id });

				if (!findNotification)
				{
					state[types.STATE_NOTIFICATIONS].push(notification)
				}
			}
		}
	},

	[types.MUTATE_SET_LASTNOTIFICATIONID]: (state, payload) =>
	{
		log("MUTATE_SET_LASTNOTIFICATIONID")
		state[types.STATE_LASTNOTIFICATIONID] = payload
		localStorage.setItem(types.STATE_LASTNOTIFICATIONID, payload)
	},

	[types.MUTATE_SET_NOTIFICATION_SHOWN]: (state, payload) =>
	{
		log("MUTATE_SET_NOTIFICATION_SHOWN")
		state[types.STATE_NOTIFICATION_SHOWN] = payload
	},

	[types.MUTATE_SET_IS_NOTIFICATION_SHOWN]: (state, payload) =>
	{
		log("MUTATE_SET_IS_NOTIFICATION_SHOWN: " + payload)
		state[types.STATE_IS_NOTIFICATION_SHOWN] = payload
	}
};

const actions = {
	async [types.ACTION_AUTHENTICATE_CREDENTIALS]({ commit }, payload)
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_AUTHENTICATE_CREDENTIALS, payload: payload })

		return UserService.authenticateUser(payload).then(response =>
		{
			commit(types.MUTATE_SET_USER_DATA, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_AUTHENTICATE_CREDENTIALS, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_LOGOUT_USER]: ({ commit, state }) =>
	{
		log("ACTION_LOGOUT_USER")
		commit(types.MUTATE_SET_IS_USER_LOGGED_IN, false);
		commit(types.MUTATE_CLEAR_USER_DATA);
		clearInterval(state.notificationPollInterval);
		state.notificationPollInterval = null
		location = "/";
	},

	[types.ACTION_CHECK_IS_USER_LOGGED_IN]: ({ commit, state }) =>
	{
		var user = state[types.STATE_USER]

		if (!user)
		{
			user = localStorage.getItem(types.STATE_USER)

			if (user)
			{
				const userData = JSON.parse(user)
				commit(types.MUTATE_SET_USER_DATA, userData)
				user = userData
			}
		}

		if (user)
		{
			try
			{
				var now = new Date()
				var expiryDate = new Date(user.expiration);
				expiryDate.setTime(expiryDate.getTime() + now.getTimezoneOffset() * 60 * 1000);

				if (expiryDate.getTime() > now.getTime())
				{
					return authenticationEnum.LOGGED_IN
				}
				else
				{
					return authenticationEnum.TOKEN_EXPIRED
				}
			}
			catch { }
		}

		return authenticationEnum.NOT_LOGGED_IN
	},

	[types.ACTION_GET_USER]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_USER, payload: payload })

		return UserService.getUser(payload).then(response =>
		{
			commit(types.MUTATE_SET_USER_DATA, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_USER, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_UPDATE_USER]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_UPDATE_USER, payload: payload })

		return UserService.updateUser(payload.id, payload).then(response =>
		{
			commit(types.MUTATE_SET_USER_DATA, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_UPDATE_USER, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GET_USER_RECENTITEMS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_USER_RECENTITEMS, payload: payload })

		return UserService.getRecentItems(payload).then(response =>
		{
			commit(types.MUTATE_SET_USER_RECENTITEMS, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_USER_RECENTITEMS, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_INIT_NOTIFICATIONS]: ({ dispatch, getters, commit }) =>
	{
		log("ACTION_INIT_NOTIFICATIONS")

		if (getters[types.GET_IS_USER_LOGGED_IN] && state.notificationPollInterval == null)
		{
			let lastNotificationID = getters[types.GET_LASTNOTIFICATIONID]

			if (!lastNotificationID)
			{
				lastNotificationID = localStorage.getItem(types.STATE_LASTNOTIFICATIONID)

				if (lastNotificationID)
				{
					commit(types.MUTATE_SET_LASTNOTIFICATIONID, lastNotificationID)
				}
			}

			dispatch(types.ACTION_GET_NOTIFICATIONS, true)

			state.notificationPollInterval = setInterval(function ()
			{
				dispatch(types.ACTION_GET_NOTIFICATIONS, true)
			}.bind(this), 5000);
		}
	},

	[types.ACTION_GET_NOTIFICATIONS]: ({ commit, getters, dispatch }, onlyUnreadNotifications) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_NOTIFICATIONS, payload: onlyUnreadNotifications })

		let lastNotificationID = getters[types.GET_LASTNOTIFICATIONID]

		return UserService.getNotifications(onlyUnreadNotifications, lastNotificationID).then(response =>
		{
			if (response.data && response.data.length > 0)
			{
				let notification = response.data[response.data.length - 1]
				let lastNotificationID = getters[types.GET_LASTNOTIFICATIONID]

				if (!lastNotificationID || notification.id > lastNotificationID)
				{
					commit(types.MUTATE_ADD_NOTIFICATIONS, response.data)
					commit(types.MUTATE_SET_LASTNOTIFICATIONID, notification.id)
					dispatch(types.ACTION_SHOW_NOTIFICATION, notification)
				}
			}
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_NOTIFICATIONS, message: error.response, payload: onlyUnreadNotifications });
		});
	},

	[types.ACTION_SHOW_NOTIFICATION]: ({ commit, getters }, notification) =>
	{
		log("ACTION_SHOW_NOTIFICATION")
		
		var shownNotification = getters[types.GET_NOTIFICATION_SHOWN]

		if (!shownNotification)
		{
			commit(types.MUTATE_SET_NOTIFICATION_SHOWN, notification)
			commit(types.MUTATE_SET_IS_NOTIFICATION_SHOWN, true)

			setInterval(function ()
			{
				commit(types.MUTATE_SET_IS_NOTIFICATION_SHOWN, false)

				setInterval(function ()
				{
					commit(types.MUTATE_SET_NOTIFICATION_SHOWN, null)
				}.bind(this), 2000);
			}.bind(this), 5000);
		}
	}
}

export default
	{
		state,
		mutations,
		actions,
		getters
	}